import {
    AfterContentInit,
    Component,
    ContentChild,
    ContentChildren,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    QueryList
} from "@angular/core";
import { VersatileListItemDirective } from "@app/shared/components";
import { VersatileListBodyAfterDirective } from "@app/shared/components";

@Component({
    selector: 'app-versatile-list-body',
    templateUrl: './versatile-list-body.component.html',
    styleUrls: ['./versatile-list-body.component.scss']
})
export class VersatileListBodyComponent implements AfterContentInit {
    @Input() items: any[] = [];
    @Input() total = 0;
    @Input() isLoading = false;
    @Input() loadingLabel = 'Loading...';
    @Input() useVirtualScroll = true;

    @Output() reachEnd = new EventEmitter<any>();

    @ContentChild(VersatileListItemDirective) itemTemplate?: VersatileListItemDirective;
    @ContentChildren(VersatileListBodyAfterDirective,
        { descendants: true }) bodyAfterTemplates?: QueryList<VersatileListBodyAfterDirective>;
    @ContentChildren('[versatileListEmpty]', { descendants: true }) emptyState?: QueryList<any>;

    @HostBinding('class.body') hostClass = true;

    hasBodyAfter = false;
    hasEmptyState = false;

    get hasItems(): boolean {
        return Array.isArray(this.items) && this.items.length > 0;
    }

    onEnd(event: any): void {
        if (this.isLoading) {
            return;
        }
        if (this.total && this.items?.length >= this.total) {
            return;
        }
        this.reachEnd.emit(event);
    }

    ngAfterContentInit(): void {
        this.hasBodyAfter = !!this.bodyAfterTemplates?.length;
        this.hasEmptyState = !!this.emptyState?.length;

        this.bodyAfterTemplates?.changes?.subscribe(list => this.hasBodyAfter = list.length > 0);
        this.emptyState?.changes?.subscribe(list => this.hasEmptyState = list.length > 0);
    }
}
